// Public (unauthenticated) API for the customer-facing cloud users web form.
// Access is gated by the tokenized link, so NO Authorization header is sent
// (mirrors Session.js).
const CloudUsersForm = {
  load: async function (client_uuid, token) {
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users-form/${token}`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  submit: async function (client_uuid, token, payload) {
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users-form/${token}`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(payload),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
};

export default CloudUsersForm;
